import _Promise2 from "babel-runtime/core-js/promise";
import _JSON$stringify from "babel-runtime/core-js/json/stringify";
import _Promise from "babel-runtime/core-js/promise";
import axios from "axios";
import qs from "qs";
import { Message } from 'element-ui';
import store from '@/vuex';

// 错误提示 页面
function showErrorPage(router, code, message) {
  var url = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  router.push({ name: 'errorPage', params: { code: code, message: message, url: url } });
}

//安全测评请求过滤非法字符
function escape2Html(obj) {
  if (obj) {
    let str = JSON.stringify(obj)
    var arrEntities = { 'lt': '<', 'gt': '>', 'nbsp': ' ', 'amp': '&', 'quot': '"' };
    str = str.toString().replace(/&(lt|gt|nbsp|amp|quot);/ig, function (all, t) { return arrEntities[t]; });
    str = str.replace(/<script.*?>.*?<\/script>/ig, '');
    str = str.replace(/<iframe.*?>.*?<\/iframe>/ig, '');
    str = str.replace(/alert/ig, '');
    // str = str.replace(/<\/?[^>]*>/ig,'');//去除html标签
    // str = str.replace(/\//ig,'');//去除字符串中的所有斜杠
    // str = str.replace(/\"/ig,'');//去除字符串中的所有双引号
    // str = str.replace(/>/ig, '');
    return JSON.parse(str);
  }
}

export default function axiosSetting(config, router) {
  //axios.defaults.baseURL = config.baseName;
  axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
  axios.defaults.headers['vue-host'] = process.env.VUE_HOST;

  // 添加请求拦截器
  axios.interceptors.request.use(function (config) {
    // 获取到用户信息并添加到请求头的token中，后端session无效时的校验
    if (store.state.userInfo.userid) {
      config.headers['x_ticket'] = store.state.userInfo.userid + '_' + store.state.userInfo.version;
    }
    return config;
  }, function (error) {
    // 对请求错误做些什么
    return _Promise2.reject(error);
  });

  // respone拦截器 这里可以添加请求结束后的操作
  axios.interceptors.response.use(function (response) {
    // 请求成功
    if (response.status >= 200 && response.status < 300) {
      if (response.data.code === 200) {
        return response.data.data;
      } else if (response.data.code === 302) {
        // 重定向
        window.location.href = JSON.parse(response.data.message).redirect_url;
        return;
      } else if ([401].indexOf(response.data.code) !== -1) {
        // 未认证 提示 跳错误页
        var indexServerUrl = response.data.data.indexServer ? response.data.data.indexServer.url : null;
        showErrorPage(router, response.data.code, response.data.message, indexServerUrl);
      } else if (response.data.code === 601) {
        // 从门户过来的消息或任务不存在或被删除撤回
        router.push({ name: 'NoMessage' });
        return;
      }  else if (!response.data.code) {
        return response.data;
      }else {
        Message({
          showClose: true,
          message: response.data.message,
          type: 'error'
        });
      }
      // return false
    } else if ([401, 403, 500, 501, 502, 504].indexOf(response.status) !== -1) {
      // 未认证 提示 跳错误页
      showErrorPage(response.status, response.data);
    } else {
      // error 提示
      Message({
        showClose: true,
        message: response.data.message || response.statusText,
        type: 'error',
        duration: config.timeout || 15000
      });
    }
    return _Promise.reject(response);
  }, function (err) {
    if ([400, 401, 500, 403, 503].indexOf(err.response.status) !== -1) {
      Message({
        showClose: true,
        message: err.response.data.error_description,
        type: 'error',
      });
      window.location.href=`${process.env.LOGIN_URL}/api/oauth2/authorize?client_id=${process.env.CLIENT_ID}&redirect_uri=${process.env.REDIRECT_URI}&response_type=code`
    } else {
      return _Promise.reject(err);
    }
  });

  return {
    get: function get(url, data) {
      var obj = data || {};
      obj['sendIeTime'] = new Date().getTime();
      return axios({
        method: "get",
        url: url,
        params: obj
      });
    },
    post2: function post2(url, data) {
      return axios({
        method: "post",
        url: url,
        data: qs.stringify(data),
        headers: {
          "content-type": "application/x-www-form-urlencoded"
        }
      });
    },
    post: function post(url, data) {
      return axios({
        method: "post",
        url: url,
        data: data,
        headers: {
          "content-type": "application/json;charset=utf-8"
        }
      });
    },
    delete: function _delete(url, data) {
      return axios({
        method: "delete",
        url: url,
        params: data
      });
    },
    put: function put(url, data) {
      return axios({
        method: "put",
        url: url,
        data: data,
        headers: {
          "content-type": "application/json;charset=utf-8"
        }
      });
    },
    put2: function put2(url, data) {
      return axios({
        method: "put",
        url: url,
        params: data
      });
    },

    // 模拟存储接口
    setItem: function setItem(name, data) {
      var json = _JSON$stringify(data);
      return window.localStorage.setItem(name, json);
    },

    // 模拟获取接口
    getItem: function getItem(name) {
      return JSON.parse(window.localStorage.getItem(name));
    },

    //获取cookie
    getCookie: function getCookie(cookie_name) {
      var allcookies = document.cookie;
      var cookie_pos = allcookies.indexOf(cookie_name); //索引的长度
      // 如果找到了索引，就代表cookie存在，
      // 反之，就说明不存在。
      if (cookie_pos != -1) {
        // 把cookie_pos放在值的开始，只要给值加1即可。
        cookie_pos += cookie_name.length + 1;
        var cookie_end = allcookies.indexOf(";", cookie_pos);
        if (cookie_end == -1) {
          cookie_end = allcookies.length;
        }
        var value = unescape(allcookies.substring(cookie_pos, cookie_end)); //这里就可以得到你想要的cookie的值了。。。
      }
      return value;
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ../vue-common-laboratory/dist/utils/requst.js
// module id = /Dpe
// module chunks = 115